module.exports = __webpack_public_path__ + "assets/img/android-chrome-96x96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/android-chrome-96x96.png
// module id = 1917
// module chunks = 0